import Modal from "../Modal";
import GrClose from "@meronex/icons/gr/GrClose";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RewardsPopupModal = function RewardsPopupModal() {
  var _ref2, _redux$showRewardsMod, _redux$deals;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    _ref$isPoints = _ref.isPoints,
    isPoints = _ref$isPoints === void 0 ? false : _ref$isPoints;
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var dealAction = (redux === null || redux === void 0 ? void 0 : redux.dealAction) || {};
  var showRewardsModal = (_ref2 = (_redux$showRewardsMod = redux === null || redux === void 0 ? void 0 : redux.showRewardsModal) !== null && _redux$showRewardsMod !== void 0 ? _redux$showRewardsMod : redux === null || redux === void 0 || (_redux$deals = redux.deals) === null || _redux$deals === void 0 ? void 0 : _redux$deals.showRewardsModal) !== null && _ref2 !== void 0 ? _ref2 : false;
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {}
  };
  var handleCloseRewardsModal = function handleCloseRewardsModal() {
    if (dispatch && typeof (dealAction === null || dealAction === void 0 ? void 0 : dealAction.setShowRewardsModal) === "function") {
      dispatch(dealAction.setShowRewardsModal(false));
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    className: "w-[95%] md:w-[50%] lg:w-[45%] xl:w-[30%]",
    visible: showRewardsModal,
    onClick: handleCloseRewardsModal,
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex justify-end mr-4 mt-4",
      children: /*#__PURE__*/_jsx(GrClose, {
        onClick: handleCloseRewardsModal,
        className: "h-4 w-4 cursor-pointer self-end ml-auto"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "text-center px-4 py-2",
      children: [/*#__PURE__*/_jsx("p", {
        className: "text-sm lg:text-base font-medium",
        children: "We noticed you have an unused points balance and more products to claim."
      }), /*#__PURE__*/_jsxs("div", {
        className: "mt-6 flex items-center gap-3 mb-4",
        children: [/*#__PURE__*/_jsx("button", {
          onClick: function onClick() {
            handleCloseRewardsModal();
            (history === null || history === void 0 ? void 0 : history.push) && history.push(isPoints ? "/rewardpointstore" : "/rewardStore");
          },
          className: "flex w-[50%] p-[10px] px-[5px] items-center gap-2 border justify-center border-primary font-normal text-primary rounded-md transition text-sm",
          children: /*#__PURE__*/_jsx("span", {
            children: "Add more products"
          })
        }), /*#__PURE__*/_jsx("button", {
          onClick: function onClick() {
            handleCloseRewardsModal();
            (history === null || history === void 0 ? void 0 : history.push) && history.push("/checkout".concat(isPoints ? "?isPoints=true" : ""));
          },
          className: "flex rounded-md w-[50%] p-[10px] px-[5px] text-center bg-primary flex items-center justify-center text-white font-normal text-sm",
          children: /*#__PURE__*/_jsx("span", {
            children: "Proceed Anyway"
          })
        })]
      })]
    })]
  });
};
export default RewardsPopupModal;